/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateMedicalSystemSetupBaseDto } from './CreateOrUpdateMedicalSystemSetupBaseDto';
import {
    instanceOfCreateOrUpdateMedicalSystemSetupBaseDto,
    CreateOrUpdateMedicalSystemSetupBaseDtoFromJSON,
    CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped,
    CreateOrUpdateMedicalSystemSetupBaseDtoToJSON,
} from './CreateOrUpdateMedicalSystemSetupBaseDto';

/**
 * @type CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup
 * 
 * @export
 */
export type CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup = CreateOrUpdateMedicalSystemSetupBaseDto;


export function CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSON(json: any): CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup {
    return CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped(json, true) };
    return  CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped(json, true);
}

export function CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupToJSON(value?: CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateOrUpdateMedicalSystemSetupBaseDto(value)) {
        return CreateOrUpdateMedicalSystemSetupBaseDtoToJSON(value as CreateOrUpdateMedicalSystemSetupBaseDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDtoMedicalSystemSetup(value: any): value is CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup {
    if (instanceOfCreateOrUpdateMedicalSystemSetupBaseDto(value)) return true;
    return false;
}

